import styled from 'styled-components';
import { MenuWidth } from 'Constants';

export const Wrapper = styled.section`
  padding-left: ${MenuWidth};
`;
